import type {Stat} from 'shells/email-latest-outreach-list/types';

import {
    SUBJECT,
    PREVIEW_TEXT,
    CONTENT,
} from '../editions/a-b-testing/comparison-fields-select-modal';

export function getFieldsToCompare(fields: Array<string>) {
    return {
        shouldCompareSubject: fields.includes(SUBJECT),
        shouldCompareContent: fields.includes(CONTENT),
        shouldComparePreviewText: fields.includes(PREVIEW_TEXT),
    };
}

type EmailEngagementStats = {
    totalSentCount: number;
    openRate: number | null | undefined;
    clickRate: number | null | undefined;
    permanentBounceRate: number | null | undefined;
};

export function convertEmailEngagementStatsToGeneralStatObject(
    engagementStats: EmailEngagementStats
): Stat[] {
    return [
        {
            title: 'Deliveries',
            value: engagementStats && engagementStats.totalSentCount,
            format: {
                type: 'integer',
                useLocale: true,
            },
        },
        {
            title: 'Open rate',
            value: engagementStats && engagementStats.openRate,
            format: {
                type: 'percent',
            },
        },
        {
            title: 'Click rate',
            value: engagementStats && engagementStats.clickRate,
            format: {
                type: 'percent',
            },
        },
        {
            title: 'Bounce rate',
            value: engagementStats && engagementStats.permanentBounceRate,
            format: {
                type: 'percent',
            },
        },
    ];
}

type SmsEngagementStats = {
    totalSentCount: number;
    responseCount: number;
    undeliveredRate: number | null | undefined;
    optoutRate: number | null | undefined;
};

export function convertSmsEngagementStatsToGeneralStatObject(
    engagementStats: SmsEngagementStats
): Stat[] {
    return [
        {
            title: 'Messages sent',
            value: engagementStats.totalSentCount,
            format: {
                type: 'integer',
                useLocale: true,
            },
        },
        {
            title: 'Responses',
            value: engagementStats.responseCount,
            format: {
                type: 'integer',
                useLocale: true,
            },
        },
        {
            title: 'Undeliverable rate',
            value: engagementStats.undeliveredRate,
            format: {
                type: 'percent',
            },
        },
        {
            title: 'Opt-out rate',
            value: engagementStats.optoutRate,
            format: {
                type: 'percent',
            },
        },
    ];
}
